var Curriculog = Curriculog || {};

Curriculog.DeleteDialog = (function ($, _, Backbone, DeleteDialog) {

	DeleteDialog = Curriculog.Dialog.extend({
		title: 'Warning',
		dialogClass: 'curriculog-dialog warning',
		itemType: 'itemType',
		itemName:'itemName',

		buttons: function () {
			deleteButtonText = 'Delete ' + this.capitalize(this.itemType);

			returnVal = {}
			returnVal[deleteButtonText] = 'deleteCallback';
			returnVal['Cancel'] = 'close';
			return returnVal;
		},

		message: function () {
			msg = 'Are you sure you want to delete the <span class="strong">';
			msg += this.itemName;
			msg += '</span> ';
			msg += this.itemType.toLowerCase();
			msg += '?';
			return msg;
		},

		callback: function () {},

		deleteCallback: function () {
			this.callback && this.callback();
			this.close();
		},

		capitalize: function (string) {
			var split = string.split(' ');
			result = [];

	        for (i = 0; i < split.length; i++) {
	            component = split[i];
	            result.push(component.substring(0, 1).toUpperCase());
	            result.push(component.substring(1));
	            result.push(" ");
	        }
	        return result.join("");
		},
	});
	return DeleteDialog;

})($, _, Backbone, Curriculog.DeleteDialog || {});
